/**
 * @generated SignedSource<<d01f13f7685db136a1b617b6fc71234a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type EventAttendeeStatus = "ATTENDING_IN_PERSON" | "ATTENDING_VIRTUAL" | "NOT_ATTENDING" | "PENDING_APPROVAL" | "REJECTED" | "WAITING_IN_PERSON" | "WAITING_VIRTUAL" | "%future added value";
export type EventTicketOrderStatus = "CANCELED" | "PENDING" | "REFUNDED" | "SUCCEEDED" | "%future added value";
export type StripePaymentIntentStatuses = "CANCELED" | "PROCESSING" | "REQUIRES_ACTION" | "REQUIRES_CAPTURE" | "REQUIRES_CONFIRMATION" | "REQUIRES_PAYMENT_METHOD" | "SUCCEEDED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type EventAttendContent_event$data = {
  readonly acceptingAttendance: boolean | null | undefined;
  readonly eventTicketingTiers: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
      } | null | undefined;
    }>;
    readonly totalCount: number;
  };
  readonly hasExternalUrl: boolean | null | undefined;
  readonly hasVenue: boolean | null | undefined;
  readonly id: string;
  readonly myAttendance: {
    readonly paymentStatus: StripePaymentIntentStatuses | null | undefined;
    readonly visibleStatus: EventAttendeeStatus;
  } | null | undefined;
  readonly myTicketOrder: {
    readonly id: string;
    readonly status: EventTicketOrderStatus;
  } | null | undefined;
  readonly name: string;
  readonly owner: {
    readonly __typename: "Guild";
    readonly myMembership: {
      readonly id: string;
    } | null | undefined;
    readonly name: string;
    readonly slugId: string;
  } | {
    readonly __typename: "User";
    readonly firstName: string;
    readonly lastName: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
  readonly prettyUrl: string;
  readonly rowId: string;
  readonly " $fragmentSpreads": FragmentRefs<"TierSelectionCard_event">;
  readonly " $fragmentType": "EventAttendContent_event";
};
export type EventAttendContent_event$key = {
  readonly " $data"?: EventAttendContent_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventAttendContent_event">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventAttendContent_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowId",
      "storageKey": null
    },
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "prettyUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasVenue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasExternalUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "acceptingAttendance",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "owner",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "firstName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastName",
              "storageKey": null
            }
          ],
          "type": "User",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "slugId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "GuildMembership",
              "kind": "LinkedField",
              "name": "myMembership",
              "plural": false,
              "selections": (v2/*: any*/),
              "storageKey": null
            }
          ],
          "type": "Guild",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EventAttendee",
      "kind": "LinkedField",
      "name": "myAttendance",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "visibleStatus",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "paymentStatus",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EventTicketOrder",
      "kind": "LinkedField",
      "name": "myTicketOrder",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": [
            "SORT_ORDER_ASC",
            "CREATED_AT_ASC"
          ]
        }
      ],
      "concreteType": "EventTicketingTiersConnection",
      "kind": "LinkedField",
      "name": "eventTicketingTiers",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "EventTicketingTiersEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EventTicketingTier",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v2/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "eventTicketingTiers(orderBy:[\"SORT_ORDER_ASC\",\"CREATED_AT_ASC\"])"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TierSelectionCard_event"
    }
  ],
  "type": "Event",
  "abstractKey": null
};
})();

(node as any).hash = "de355b371aaacf2d2ed1c3816f9168f5";

export default node;
